import { css } from "@emotion/react";

import React from "react";
import { ReactTFC } from "../../../../../utils/fp/missing-ts-parts";
import { fontColor, FONTS, fontSize } from "../../../../../styles/fonts";
import type { SwarovskiOptikClientCart, TranslatedValue } from "@swo/storefront";
import { T } from "../../../../T";

export const ShoppingCartDropdownSummaryElement: ReactTFC<
  React.PropsWithChildren<{
    cartPrice: { totalPrice: string };
    cartDiscount: SwarovskiOptikClientCart["computed"]["cartDiscount"];
    totalPriceLabel: TranslatedValue;
  }>
> = ({ cartPrice, cartDiscount, totalPriceLabel, children }) => {
  return (
    <div
      className="u-flex u-flex-col u-ai-center u-relative"
      css={css`
        padding: 32px 18px 15px;
      `}
    >
      {/* <span css={[FONTS.SwarovskiFutura500, fontSize.x2]}>{cartPrice.totalPrice}</span> */}

      <div
        className={"u-d-flex"}
        css={[
          fontSize.x2,
          css`
            gap: 8px;
          `,
        ]}
      >
        {cartDiscount && (
          <span
            className={"u-fw-300"}
            css={[
              priceStyles,
              FONTS.SwarovskiFutura300,
              css`
                text-decoration: line-through;
                order: 2;
                font-size: 0.875em;
                opacity: 0.65;
              `,
            ]}
          >
            {cartDiscount.preDiscount.formattedValue}
          </span>
        )}

        <span
          className={"u-fw-500"}
          css={css`
            display: flex;
            justify-content: space-between;
            gap: 4px;
          `}
        >
          <span css={fontColor.black}>{cartPrice.totalPrice}</span>
        </span>
      </div>

      <span
        css={[
          FONTS.SwarovskiFutura300,
          fontSize.x2,
          css`
            margin-bottom: 10px;
          `,
        ]}
      >
        <T>{totalPriceLabel}</T>
      </span>

      {children}
    </div>
  );
};

const priceStyles = [FONTS.SwarovskiFutura300, fontColor.black, fontSize.x2];
